import React from "react";
import { useEffect, useState } from "react";
// import "survey-core/modern.css";
import "survey-core/defaultV2.min.css";
import "survey-core/survey.i18n";
// import "survey-creator-core/survey-creator-core.min.css";
// import { surveyLocalization } from "survey-core";
// const engLocale = surveyLocalization.locales["en"];
import "./creator.css"
import '../Components/Css/apklausaVidus.css';
import { StylesManager, Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { Serializer } from "survey-core";
import { useContext } from "react";
import { GlobalStates } from "../GlobalStates";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SingleSelect from "../Components/Select/SingleSelect";
import { t } from 'i18next';
import { useSupabaseData } from "../Hooks/useSupabaseData";
import { supabase } from "../services/supabaseClient";

Serializer.findProperty("survey", "title").visible = false;
Serializer.findProperty("survey", "description").visible = false;
Serializer.findProperty("survey", "logo").visible = false;
//For Page:
Serializer.findProperty("page", "title").visible = false;
Serializer.findProperty("page", "description").visible = false;

StylesManager.applyTheme("defaultV2");

function Form(props) {
    const { i18n } = useTranslation('home');
    
    // Hide navigation bar when component mounts
    useEffect(() => {
        const nav = document.querySelector('.Navigacija');
        if (nav) nav.style.display = 'none';
        
        // Show navigation bar when component unmounts
        return () => {
            const nav = document.querySelector('.Navigacija');
            if (nav) nav.style.display = 'block';
        };
    }, []);

    const { path, token, me } = useContext(GlobalStates)
    const [surveyJson, setSurveyJson] = useState(null)
    const { id } = useParams()
    const [single, setSingle] = useState(undefined);
    const [info, setInfo] = useState([]);
    const [r, setR] = useState(0)
    const { getSingle } = useSupabaseData({ name: 'formos' })
    const { create } = useSupabaseData({ name: 'atsakymai' })
    const [survey, setSurvey] = useState(null);
    const [lng, setLng] = useState('lt')
    const [loading, setLoading] = useState(true)
    const [errorMsg, setErrorMsg] = useState('')
    useEffect(() => { getSingle(id, setSingle) }, [])
    // Vertimų objektas
    const pageTitleTranslations = {
        "1. Socialinės distancijos vertinimas": "Socialinės distancijos vertinimas",
        "2. Požiūris apie įvairovę ir įtrauktį darbo vietoje": "Požiūris apie įvairovę ir įtrauktį darbo vietoje",
        "3. Įdarbinimo vertinimas": "Įdarbinimo vertinimas",
        "4. Įvairovės ir įtraukties vertinimas darbo vietoje": "Įvairovės ir įtraukties vertinimas darbo vietoje",
        "5. Darbuotojų gerovė": "Darbuotojų gerovė",
        "6. Įtraukimas į sprendimų priėmimą": "Įtraukimas į sprendimų priėmimą",
        "7. Socialinės ir demografinės charakteristikos": "Socialinės ir demografinės charakteristikos",
        "8. Kiti klausimai (neprivaloma)": "Kiti klausimai (neprivaloma)"
    };

    const updatePageTitle = () => {
        const titleElement = document.querySelector('.sd-title.sd-page__title');
        if (titleElement) {
            const originalTitle = titleElement.textContent;
            if (pageTitleTranslations[originalTitle]) {
                titleElement.textContent = pageTitleTranslations[originalTitle];
            } else {
                // Remove number formats: "1. Title", "1 Title", and "2.1 Title"
                titleElement.textContent = titleElement.textContent.replace(/^\d+(?:\.\d+)?\.?\s+/, '');
            }
        }
    };

    useEffect(() => {
        if (surveyJson) {
            const newSurvey = new Model(surveyJson);
            
            // Add event handlers for page rendering and page changes
            const updateTitle = (titleElement, currentTitle) => {
                if (titleElement) {
                    if (pageTitleTranslations[currentTitle]) {
                        titleElement.textContent = pageTitleTranslations[currentTitle];
                    } else {
                        // Remove number formats: "1. Title", "1 Title", and "2.1 Title"
                        titleElement.textContent = currentTitle.replace(/^\d+(?:\.\d+)?\.?\s+/, '');
                    }
                }
            };

            newSurvey.onAfterRenderPage.add((sender) => {
                requestAnimationFrame(() => {
                    const titleElement = document.querySelector('.sd-title.sd-page__title');
                    if (titleElement && sender.currentPage) {
                        const currentTitle = sender.currentPage.title || sender.currentPage.name;
                        updateTitle(titleElement, currentTitle);
                    }
                });
            });

            newSurvey.onCurrentPageChanged.add((sender) => {
                requestAnimationFrame(() => {
                    const titleElement = document.querySelector('.sd-title.sd-page__title');
                    if (titleElement && sender.currentPage) {
                        const currentTitle = sender.currentPage.title || sender.currentPage.name;
                        updateTitle(titleElement, currentTitle);
                    }
                });
            });

            setSurvey(newSurvey);
        }
    }, [surveyJson]);

    useEffect(() => {
        if (single != undefined && single.attributes.formObject) {
            if (new Date(single.attributes.validTo).getFullYear() >= new Date().getFullYear()) {
                setSurveyJson(single.attributes.formObject)
                setInfo(single)
            }
            else { setErrorMsg(t('pasibaigesGaliojimas')) }
        }
    }, [single, lng])

    const surveyComplete = async (sender) => {
        if (single.attributes) {
            try {
                // Paruošiame parametrus RPC funkcijai
                const rpcParams = {
                    p_formos_pavadinimas: info.attributes.formosPavadinimas,
                    p_imones_pavadinimas: info.attributes.imonesPavadinimas,
                    p_kas_pildo: info.attributes.kasPildo,
                    p_uzpildymo_data: new Date().toISOString().split('T')[0], // YYYY-MM-DD formatas
                    p_atsakymai: sender.data,
                    p_formos_id: single.id // Pridedame formos_id, kad susieti su forma
                };
                
                const { data: result, error } = await supabase
                    .rpc('insert_anon_atsakymai', rpcParams);
                    
                if (error) {
                    console.error("Supabase RPC error:", error);
                    throw error;
                }
                
                alert("Ačiū! Jūsų atsakymai sėkmingai išsaugoti.");
            } catch (error) {
                console.error("Klaida išsaugant atsakymus:", error);
                alert("Atsiprašome, nepavyko išsaugoti atsakymų. Prašome bandyti dar kartą.");
            }
        }
    }
    useEffect(() => {
        if (survey) {
            survey.locale = lng
        }
    }, [lng, survey])
    useEffect(() => {
        if (survey && single) {
            setLoading(false)
            survey.onCurrentPageChanged.add(function(sender, options) {
                if (options.isNextPage) {
                  window.scrollTo(1, 1)};});

                

            survey.onComplete.add(surveyComplete);
            
            survey.onAfterRenderPage.add(function (_, options) {
                let other = options.htmlElement.querySelector('.sd-question__form-group span')
                if (other) {
                    if (other.innerHTML == 'OK') {
                        other.innerHTML = 'Aprašykite plačiau:'
                        other.style.paddingLeft = "10px"
                    }
                }


                if (options.page.name === "1.1: Ar sutiktumėte savo kaimynystėje gyventi su žemiau išvardintais žmonėmis?") {
                    options.htmlElement.classList.add("Kl1_1")
                } else {
                    options.htmlElement.classList.remove("Kl1_1")
                }
                if (options.page.name === "5.1: Kiek žinote apie iššūkius, su kuriais susiduria gyventojai, kurie yra:") {
                    options.htmlElement.classList.add("Kl5_1")
                } else {
                    options.htmlElement.classList.remove("Kl5_1")
                }
                if (options.page.name === "5.2: Prašome įvertinti kiekvieną klausimą apie Jūsų įmonę naudodami skalę.") {
                    options.htmlElement.classList.add("Kl5_2")
                } else {
                    options.htmlElement.classList.remove("Kl5_2")
                }
                if (options.page.name === "5.3: Prašome įvertinti kiekvieną klausimą apie Jūsų įmonę naudodami skalę.") {
                    options.htmlElement.classList.add("Kl5_3")
                } else {
                    options.htmlElement.classList.remove("Kl5_3")
                }
                if (options.page.name === '6.1: Prašome įvertinti kiekvieną klausimą apie Jūsų įmonę naudodami skalę.') {
                    options.htmlElement.classList.add("Kl6_1")
                } else {
                    options.htmlElement.classList.remove("Kl6_1")
                }
                if (options.page.name === '4.2: Kaip Jūs vertinate šias hipotetines situacijas:') {
                    options.htmlElement.classList.add("Kl4_2")
                } else {
                    options.htmlElement.classList.remove("Kl4_2")
                }
                if (options.page.name === '4.1: Ar darbovietėje girdėjote nemalonių komentarų ar juokelių apie save arba kitus asmenis?') {
                    options.htmlElement.classList.add("Kl4_1")
                } else {
                    options.htmlElement.classList.remove("Kl4_1")
                }
                if (options.page.name === '4.3: Ar patyrėte diskriminaciją arba su Jumis buvo elgiamasi nesąžiningai dabartinėje darbo vietoje dėl Jūsų:') {
                    options.htmlElement.classList.add("Kl4_3")
                } else {
                    options.htmlElement.classList.remove("Kl4_3")
                }
                if (options.page.name === '4.3: Ar patyrėte diskriminaciją arba ar su Jumis buvo elgiamasi nesąžiningai dabartinėje darbo vietoje dėl Jūsų: (be balų)') {
                    options.htmlElement.classList.add("Kl4_3")
                } else {
                    options.htmlElement.classList.remove("Kl4_3")
                }
                if (options.page.name === '4.4: Ar žinote kolegą (-ę), kurie darbovietėje buvo diskriminuojami dėl savo:') {
                    options.htmlElement.classList.add("Kl4_4")
                } else {
                    options.htmlElement.classList.remove("Kl4_4")
                }
                if (options.page.name === '4.4: Ar žinote kolegą (-ę), kurie darbovietėje buvo diskriminuojami dėl savo: (be balų)') {
                    options.htmlElement.classList.add("Kl4_4")
                } else {
                    options.htmlElement.classList.remove("Kl4_4")
                }
                if (options.page.name === '4.5: Jei Jūs ar Jūsų kolega patirtų diskriminacijos darbo vietoje, ar jaustumėtės saugus  apie tai papasakoti kolegoms?') {
                    options.htmlElement.classList.add("Kl4_5")
                } else {
                    options.htmlElement.classList.remove("Kl4_5")
                }
                if (options.page.name === '4.6: Ar Jūsų darbo vietoje yra saugus pranešimo kanalas?') {
                    options.htmlElement.classList.add("Kl4_6")
                } else {
                    options.htmlElement.classList.remove("Kl4_6")
                }
                if (options.page.name === '4.7:  Jei Jūs ar Jūsų kolega patirtų diskriminaciją darbo vietoje, ar norėtumėte apie tai pranešti?') {
                    options.htmlElement.classList.add("Kl4_7")
                } else {
                    options.htmlElement.classList.remove("Kl4_7")
                }
                if (options.page.name === '5.4:  Ar dabartinėje darbo vietoje teko patirti patyčių ar priekabiavimo?') {
                    options.htmlElement.classList.add("Kl5_4")
                } else {
                    options.htmlElement.classList.remove("Kl5_4")
                }
                if (options.page.name === 'Lytis') {
                    options.htmlElement.classList.add("Kl7_1")
                } else {
                    options.htmlElement.classList.remove("Kl7_1")
                }
                if (options.page.name === 'Amzius') {
                    options.htmlElement.classList.add("Kl7_2")
                } else {
                    options.htmlElement.classList.remove("Kl7_2")
                }
                if (options.page.name === 'Padetis') {
                    options.htmlElement.classList.add("Kl7_3")
                } else {
                    options.htmlElement.classList.remove("Kl7_3")
                }
                if (options.page.name === 'Laikas') {
                    options.htmlElement.classList.add("Kl7_4")
                } else {
                    options.htmlElement.classList.remove("Kl7_4")
                }
                if (options.page.name === 'Pareigos') {
                    options.htmlElement.classList.add("Kl7_5")
                } else {
                    options.htmlElement.classList.remove("Kl7_5")
                }
                if (options.page.name === 'Kompiuteris') {
                    options.htmlElement.classList.add("Kl7_6")
                } else {
                    options.htmlElement.classList.remove("Kl7_6")
                }
                if (options.page.name === 'Issilavinimas') {
                    options.htmlElement.classList.add("Kl7_7")
                } else {
                    options.htmlElement.classList.remove("Kl7_7")
                }
                if (options.page.name === 'Religija') {
                    options.htmlElement.classList.add("Kl8_1")
                } else {
                    options.htmlElement.classList.remove("Kl8_1")
                }
                if (options.page.name === 'Orientacija') {
                    options.htmlElement.classList.add("Kl8_2")
                } else {
                    options.htmlElement.classList.remove("Kl8_2")
                }
                if (options.page.name === 'Negalia') {
                    options.htmlElement.classList.add("Kl8_3")
                } else {
                    options.htmlElement.classList.remove("Kl8_3")
                }
                if (options.page.name === '0. welcome') {
                    options.htmlElement.classList.add("wlcm")
                } else {
                    options.htmlElement.classList.remove("wlcm")
                }
            }
            );
        }
    }, [survey])

    if (survey == null && !errorMsg && loading) return <div></div>;
    if (errorMsg) return (
        <div className="survey-container">
            <div>
                <div className='apklausaKalbos formoje pasibaiges'>
                    <div>{errorMsg}</div>
                </div>
                <div className='apklausaKalbos formoje'>
                    <SingleSelect
                        sx0={{ minWidth: 0 }}
                        sx={{ m: 1, width: 70 }}
                        sx1={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                        classNameSelectLabel='kalbaSelectLabel'
                        label={lng}
                        className={'apklausaKalba'}
                        options={t('kalba')}
                        optionsText={t('kalba_text')}
                        set={(l, v) => { setLng(l); i18n.changeLanguage(l) }}
                        current={lng}

                    />
                </div>
            </div>

        </div>)
    return <div className="survey-container">
        <div>
            <div className='apklausaKalbos formoje'>
                <SingleSelect
                    sx0={{ minWidth: 0 }}
                    sx={{ m: 1, width: 70 }}
                    sx1={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                    classNameSelectLabel='kalbaSelectLabel'
                    label={lng}
                    className={'apklausaKalba'}
                    options={t('kalba')}
                    optionsText={t('kalba_text')}
                    set={(l, v) => { setLng(l); i18n.changeLanguage(l) }}
                    current={lng}

                />
            </div>
        </div><Survey model={survey} /></div>;
}
export default Form;
